import { requestJson, buildQuery } from "./apiClient";

export function listPendingPublishing(params = {}) {
  return requestJson(`/api/admin/client-publishing/pending${buildQuery(params)}`);
}

export function getPublishingDetail(contentVersionId) {
  return requestJson(`/api/admin/client-publishing/${contentVersionId}`);
}

export function previewPublishing(contentVersionId) {
  return requestJson(`/api/admin/client-publishing/${contentVersionId}/preview`);
}

export function approvePublishing(contentVersionId, body = {}) {
  return requestJson(`/api/admin/client-publishing/${contentVersionId}/approve`, {
    method: "POST",
    body: JSON.stringify(body),
  });
}

export function rejectPublishing(contentVersionId, body) {
  return requestJson(`/api/admin/client-publishing/${contentVersionId}/reject`, {
    method: "POST",
    body: JSON.stringify(body),
  });
}

export function publishPublishing(contentVersionId) {
  return requestJson(`/api/admin/client-publishing/${contentVersionId}/publish`, {
    method: "POST",
    body: JSON.stringify({}),
  });
}

export function rollbackPublishing(contentVersionId, body) {
  return requestJson(`/api/admin/client-publishing/${contentVersionId}/rollback`, {
    method: "POST",
    body: JSON.stringify(body),
  });
}
